document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.alphabet-button');
  const collectionItems = document.querySelectorAll('.vendor-collection-item');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove active class from all buttons and add it to the clicked one
      buttons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Get the selected letter
      const letter = button.getAttribute('data-letter');

      // Show or hide collections based on the selected letter
      collectionItems.forEach(item => {
        item.style.display = item.getAttribute('data-group') === letter ? 'block' : 'none';
      });
    });
  });

  // Trigger the first button to show collections starting with "A" on load
  document.querySelector('.alphabet-button[data-letter="A"]').click();
});
